
const UploadCloudIcon = ({ 
  color = "#6B635D", 
  size = 24, 
  className = "",
  ...props 
}) => {
  return (
   <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.9537 63.3333C13.0637 63.3333 6.66699 57.0133 6.66699 49.2167C6.66699 41.42 13.0637 35.0967 20.9537 35.0967C21.9025 35.0989 22.8248 35.1878 23.7203 35.3633M23.7203 35.3633C22.939 33.2715 22.5393 31.0564 22.5403 28.8233C22.5403 18.4267 31.067 10 41.587 10C51.387 10 59.457 17.3133 60.5203 26.7167M23.7203 35.3633C25.5644 35.7224 27.3199 36.4404 28.887 37.4767M47.937 26.7567C49.979 26.0475 52.1254 25.6858 54.287 25.6867C56.467 25.6867 58.5637 26.05 60.5203 26.7167M60.5203 26.7167C67.9737 29.2667 73.3337 36.27 73.3337 44.51C73.3337 53.5333 66.9103 61.0767 58.3337 62.91" stroke="#1C2A46" stroke-width="2.5" stroke-linecap="round"/>
<path d="M40.0007 53.333V73.333M40.0007 53.333L46.6673 59.9997M40.0007 53.333L33.334 59.9997" stroke="#1C2A46" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  );
};


export { 
 UploadCloudIcon
};
